import React, { useReducer, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import gql from "graphql-tag";
import { useMutation, useQuery } from "@apollo/react-hooks";

import qs from 'query-string'

import Layout from "layouts/onboarding";

import Wizard from "modules/onboarding/wizard";
import {
  reducer,
  setStep,
} from "modules/onboarding/state";

const UserData = React.lazy(() => import("modules/onboarding/user-data"));
const PleaseActivate = React.lazy(() => import("modules/onboarding/please-activate"));

const initialState = {
  step: 1,
  paymentType: "YEAR",
};

const SIGNUP_MUTATION = gql`
  mutation signup($values: SignupInput) {
    signup(input: $values) {
      token
    }
  }
`
const GET_PLANS_JSON_BY_ID = gql`
  query getPlansJsonById($id: Int) {
    getPlansJsonById(id: $id) {
      id
      data
    }
  }
`

function SignUpPage() {
  const [state, dispatch] = useReducer(reducer, initialState);

  const { step } = state;

  const { search } = useLocation()

  const { planID, paymentFrequency } = React.useMemo(() => {

    const parsedQs = qs.parse(search)
    const { freq, plan } = parsedQs
    
    return { paymentFrequency: freq, planID: plan }
  }, [search])

  const [signup] = useMutation(SIGNUP_MUTATION);

  const { data } = useQuery(GET_PLANS_JSON_BY_ID, { variables: { id: parseInt(planID, 10) }});
  
  const { planData, hasOrganization } = useMemo(() => {

    if (data) {
      const planData = data.getPlansJsonById.data
      const parsedPlanData = JSON.parse(planData)
      const hasOrganization = parsedPlanData.id !== 1

      return { planData: parsedPlanData, hasOrganization}
    }

    return { planData: null, hasOrganization: null }

  },[data])

  const handleSignup = React.useCallback(async function handleSignup(values) {
    const { passwordConfirm, ...submittedValues } = values

    try {
      await signup({
        variables: {
          values: {
            ...submittedValues,
            pid: `${planID}`,
          }
        }
      })

      dispatch(setStep(2))

    } catch (err) {
      throw err
    }

  }, [signup, planID])

  return (
    <Layout
      wizard={<Wizard activeStep={step} />}
      cta={
        <Link to="/sign-in" className="cursor-pointer">
          Già registrato? Accedi
        </Link>
      }
    >
      {step === 1 && planData && (
        <UserData
          planData={planData}
          isAnnualPayment={paymentFrequency === "YEAR"}
          hasOrganization={hasOrganization}
          onSubmit={handleSignup}
        />
      )}
      {step === 2 && <PleaseActivate />}
    </Layout>
  );
}

export default SignUpPage;
